;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import cx from 'clsx';
import PropTypes from 'prop-types';

import Text from 'components/ui/Text';

import styles from './ResultHeader.module.scss';

const ResultHeader = ({
    type = '',
    number = 0,
    showNumberOfResults = true,
    isLoading = true,
    countLabel,
}) => {
    return (
        <div
            className={cx(styles.root, {
                [styles.isLoading]: isLoading,
            })}
        >
            <Text
                as="h2"
                baseTheme="searchResultsLarge"
                className={styles.headline}
            >
                <>
                    {type}
                    {isLoading ? (
                        <span
                            className={cx(styles.loading, styles.subhead)}
                            aria-hidden
                        >
                            <span>.</span>
                            <span>.</span>
                            <span>.</span>
                        </span>
                    ) : (
                        showNumberOfResults && (
                            <Text
                                baseTheme="searchResultsSmall"
                                className={styles.subhead}
                            >
                                {countLabel
                                    ? `(${number} ${countLabel})`
                                    : `(${number} ${number === 1 ? 'fav' : 'faves'})`}
                            </Text>
                        )
                    )}
                </>
            </Text>
        </div>
    );
};

ResultHeader.propTypes = {
    type: PropTypes.string.isRequired,
    number: PropTypes.number,
    showNumberOfResults: PropTypes.bool,
    isLoading: PropTypes.bool,
    countLabel: PropTypes.string,
};

export default ResultHeader;
